import React, { useState  } from 'react';
import axios from "axios";
// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import LoadingButton from '@mui/lab/LoadingButton';


import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


function NewsContents(props){

    return (
        <div id="tcblog">
            <div className='select_body'>
                <div style={{textAlign:'left',marginBottom:'10px',}}>
                    <h1 className='linetitle'>採用 LINE</h1>
                </div>
                <div style={{textAlign:'left'}}>
                    <TextField id="outlined-basic" label="名前" variant="outlined" fullWidth />
                    <div style={{paddingTop:'20px'}}>
                        <FormLabel component="legend">新卒・中途</FormLabel>
                        <FormGroup style={{paddingLeft:'10px'}}>
                            <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="新卒" />
                            <FormControlLabel control={<Checkbox size="small" />} label="中途" />
                        </FormGroup>
                    </div>
                </div>
            </div>
            
            

            
            
            <style jsx="true">{
                `
                .linetitle{
                    font-size:18px;
                }
                .top_buttons{
                    text-align:left;
                }
                .ck-editor__editable {
                    min-height: 500px;
                }
                .savebox{
                    padding-top:20px;
                    text-align:right;
                }

                `
            }
            </style>
        </div>
    );
    // }
};
// root.render(<HelloMessage name="Taylor" />);
export default NewsContents;




